import { render, staticRenderFns } from "./addResult.vue?vue&type=template&id=612dba8a&scoped=true"
import script from "./addResult.vue?vue&type=script&lang=js"
export * from "./addResult.vue?vue&type=script&lang=js"
import style0 from "./addResult.vue?vue&type=style&index=0&id=612dba8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612dba8a",
  null
  
)

export default component.exports